<ts-dialog [title]="title" (closeDialog)="dialogRef.close(false)">
  <div ts-dialog-body>
    <p>
      @if (renderHtml) {
        <div [innerHTML]="description"></div>
      } @else {
        {{ description }}
      }
    </p>
    @if (hasError) {
      <p class="error-message">
        {{ errorMessage }}
      </p>
    }
  </div>
  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close(false)">{{ noLabel }}</ts-button>
    <ts-button [variant]="yesStylingVariant" (click)="dialogRef.close(true)">{{ yesLabel }}</ts-button>
  </div>
</ts-dialog>

<style>
  .error-message {
    color: #d32f2f;
    margin-top: 16px;
    font-weight: 500;
  }
</style>
